<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('user.withdraw.nickname')" prop="nickname">
                <a-input v-model="queryParam.nickname" :placeholder="$t('system.inputPlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('user.withdraw.email')" prop="email">
                <a-input v-model="queryParam.email" :placeholder="$t('system.inputPlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('user.withdraw.mobile')" prop="mobile">
                <a-input v-model="queryParam.mobile" :placeholder="$t('system.inputPlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('user.withdraw.status')" prop="status">
                <a-select v-model="queryParam.status" :placeholder="$t('system.selectPlaceholder')" allow-clear>
                  <a-select-option :value="0">{{ $t('user.withdraw.statusPending') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('user.withdraw.statusRejected') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('user.withdraw.statusApproved') }}</a-select-option>
                  <a-select-option :value="3">{{ $t('user.withdraw.statusPaid') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 5 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1800}"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />{{ $t('user.withdraw.audit') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageWithdraw,listWithdraw, delWithdraw } from '@/api/user/withdraw'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Withdraw',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        nickname: null,
        email: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('user.withdraw.nickname'),
          dataIndex: 'nickname',
          fixed: 'left',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('user.withdraw.email'),
          dataIndex: 'email',
          fixed: 'left',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('user.withdraw.mobile'),
          dataIndex: 'mobile',
          fixed: 'left',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('user.withdraw.money'),
          dataIndex: 'money',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('user.withdraw.realMoney'),
          dataIndex: 'realMoney',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('user.withdraw.serviceCharge'),
          dataIndex: 'serviceChargeNum',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('user.withdraw.status'),
          dataIndex: 'status',
          width: 120,
          align: 'center',
          customRender: (status) => {
            if (status === 0) {
              return this.$t('user.withdraw.statusPending')
            } else if (status === 1) {
              return this.$t('user.withdraw.statusRejected')
            } else if (status === 2) {
              return this.$t('user.withdraw.statusApproved')
            } else if (status === 3) {
              return this.$t('user.withdraw.statusPaid')
            }
          }
        },
        {
          title: this.$t('user.withdraw.type'),
          dataIndex: 'withdrawType',
          width: 120,
          align: 'center',
          customRender: (withdrawType) => {
            if (withdrawType === 1) {
              return this.$t('user.withdraw.typePaypal')
            } else if (withdrawType === 2) {
              return this.$t('user.withdraw.typeBank')
            } else if (withdrawType === 3) {
              return this.$t('user.withdraw.typeAlipay')
            }
          }
        },
        {
          title: this.$t('user.withdraw.auditOpinion'),
          dataIndex: 'auditOpinion',
          width: 220,
          align: 'center',
          customRender: (auditOpinion) => {
            if (auditOpinion) {
              return auditOpinion
            } else {
              return this.$t('user.withdraw.none')
            }
          }
        },
        {
          title: this.$t('user.withdraw.applyTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: 120,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  watch: {
  },
  methods: {
    /** 查询用户提现记录列表 */
    getList () {
      this.loading = true
      pageWithdraw(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        money: undefined,
        realMoney: undefined,
        serviceChargeNum: undefined,
        status: undefined,
        withdrawType: undefined,
        withdrawUserType: undefined,
        orderNo: undefined,
        failureReason: undefined,
        auditOpinion: undefined,
        cateName: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('system.confirmDelete'),
        content: this.$t('system.confirmDeleteContent') + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delWithdraw(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('system.deleteSuccess'),
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('system.confirmExport'),
        content: this.$t('system.confirmExportContent'),
        onOk () {
          that.download('user/user-withdraw/export', {
            ...that.queryParam
          }, `${that.$t('user.withdraw.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
